module.exports = __webpack_public_path__ + "media/images/regphonepic1-55380a3e.svg";